export const PREDEFINED_QUESTIONS = [
  'What is target time?',
  'How frequently is progress updated?',
  'How can I get a weekly report of unloads?'
];

export const CHATBOT_NAME = 'Ask Joe';
export const CHATBOT_START_MESSAGE = 'Ask any question regarding the facility';